import ApiService from "../common/apiService";
import TokenService from "../common/tokenService";
import constants from "../common/constants";

import {
  GET_COMMITTEES,
  GET_COMMITTEE_NAMES,
  GET_MEMBERS,
  GET_EVENTS,
  ADD_EVENT,
  DELETE_EVENT,
  UPDATE_EVENT,
  UPDATE_COMMITTEE_ADMIN,
  ADD_COMMITTEE
} from "./actions.type";
import {formatDate} from "../common/formatting";

const CommitteeModule = {
  state: {
    errors: null,
    token: TokenService.getToken(),
    twoFactorAuth: {
      method: null,
      completed: null
    },

    committees:[],
    committeeNames:[],
    dropdownMembers:[],

    members:[],
    currentMembers:[],
    page: 1,
    perPage: 20,
    total: 0,
    events:[],
  },
  mutations:{
    setCommittees(state,data){
      let allCommittees = [];
      data.forEach((committee) => {
        try {
              let committee_id = {};
            let committee_name = {};
            let forum_admin = {};
            committee_id.value = committee.id;
            committee_name.value = committee.value;

            if(committee.admin_id > 0){
              forum_admin.code=committee.admin.id
              forum_admin.label = committee.admin.first_name+ ' ' + committee.admin.last_name
            }else{
              forum_admin.code=''
              forum_admin.label = ''
            }

            committee.committee_id = committee_id;
            committee.committee_name = committee_name;
            committee.forum_admin = forum_admin;
            committee.dropdown = false;
            allCommittees.push(committee)
        }catch(error) {
          console.log('ERROR: Something wrong with committee',error);
        }

      });
      state.committees = allCommittees;
    },
    setCommitteeNames(state,data){
      let allCommitteeNames = [];
      data.forEach((committee) => {
        let committee_id = {};
        let committee_name = {};
        committee_id.value = committee.id;
        committee_name.value = committee.value;
        committee.committee_id = committee_id;
        committee.committee_name = committee_name;
        allCommitteeNames.push(committee)
      });
      state.committeeNames = allCommitteeNames;
    },
    setDropDownMemberList(state,members){
      let allMemebers = [];
      members.forEach((member) => {
        let m = {};
        m.label = member.first_name + ' ' + member.last_name;
        m.value = member.id;
        allMemebers.push(m)
      });
      state.dropdownMembers = allMemebers;
    },
    setMembers(state,members){
      state.members = members;
      state.total = state.members.length;
    },
    setMembersPage(state,page){
      state.page = page;
    },
    setMembersPerPage(state,perPage){
      state.perPage = perPage;
    },
    setCurrentMembers(state){
      let first = (state.page-1) * state.perPage;
      let last = state.page * state.perPage;
      state.currentMembers = state.members.slice(first,last);
    },
    setEvents(state,events){
      /**
       * Get events from DB and convert UTC time to local time.
       */
      events.forEach((event) => {
        let time = event.start;
        event.start = formatDate(time,'YYYY-MM-DD HH:mm:ss');
        event.end = formatDate(event.end,'YYYY-MM-DD HH:mm:ss');
        event.formatDate = formatDate(time, constants.DD_MM_YYYY);
        event.formatTime = formatDate(time,'hh:mm a');
      });
      state.events = events;
    }
  },
  getters: {
    getMembers(state){
      return state.members;
    }
  },
  actions: {
    async [GET_COMMITTEES](context,payload) {
      let res = {};
      let url = "/committees";
      await ApiService.get(url)
        .then(response => {
          let items = response.data;
          res = items;
          context.commit('setCommittees',items.data);
        })
        .catch(error => {
          res = error;
        })
      return res;
    },
    async [GET_COMMITTEE_NAMES](context,payload) {
      //similar to above function, but this function can be called publicly so only gets committee ID and name
      let res = {};
      let url = "/committeenames";
      await ApiService.get(url)
        .then(response => {
          let items = response.data;
          res = items;
          context.commit('setCommitteeNames',items.data);
        })
        .catch(error => {
          res = error;
        })
      return res;
    },
    async [GET_MEMBERS](context,payload){
      let res = {};
      let url = "/committees/"+payload;
      await ApiService.get(url)
        .then(response => {
          let items = response.data;
          res = items;
          context.commit('setMembers',items.data);
          context.commit('setDropDownMemberList',items.data);
          context.commit('setCurrentMembers');
        })
        .catch(error => {
          res = error;
        })
      return res;
    },
    async [GET_EVENTS](context,payload){
      let res = {};
      let url = "/events?committee_id="+payload;
      await ApiService.get(url)
        .then(response => {
          let items = response.data;
          res = items;
          context.commit('setEvents',items.data);
        })
        .catch(error => {
          res = error;
        })
      return res;
    },
    async [ADD_EVENT](context,payload){
      let res = {};
      let url = "/events";
      await ApiService.post(url,payload)
        .then(response => {
          let items = response.data;
          res = items;
        })
        .catch(error => {
          res = error;
        })
      return res;
    },
    async [ADD_COMMITTEE](context,payload){
      let res = {};
      let url = "/committees";
      await ApiService.post(url,payload)
        .then(response => {
          let items = response.data;
          res = items;
        })
        .catch(error => {
          res = error;
        })
      return res;
    },
    async [DELETE_EVENT](context,payload){
      let res = {};
      let url = "/events/"+payload;
      await ApiService.delete(url)
        .then(response => {
          let items = response.data;
          res = items;
        })
        .catch(error => {
          res = error;
        })
      return res;
    },
    async [UPDATE_EVENT](context,payload){
      let res = {};
      let url = "/events/"+payload.event_id;
      await ApiService.put(url,payload.params)
        .then(response => {
          let items = response.data;
          res = items;
        })
        .catch(error => {
          res = error;
        })
      return res;
    },
    async [UPDATE_COMMITTEE_ADMIN](context,payload){
      let res = {};
      let url = "/committees/"+payload[0];
      await ApiService.put(url,payload[1])
        .then(response => {
          let items = response.data;
          res = items;
        })
        .catch(error => {
          res = error;
        })
      return res;
    },
    updateMemberPage(context,page){
      context.commit('setMembersPage',page);
      context.commit('setCurrentMembers');
    },
    updateMemberPerPage(context,perPage){
      context.commit('setMembersPerPage',perPage);
      context.commit('setCurrentMembers');
    }
  }
};
export default CommitteeModule;
